import { createAction } from 'redux-actions';
import { destroy } from 'redux-form';
import BlacklistActions from '../actions';

const types = {
  startCreateBlacklistWizard: 'startCreateBlacklistWizard',
  stopCreateBlacklistWizard: 'stopCreateBlacklistWizard',
  // Nombre propio: con 'setCurrentStep' también movía los otros asistentes
  // (al pasar a Usuarios aparecía "¡Nuevo usuario creado con éxito!").
  setCurrentStep: 'setCreateBlacklistWizardStep',
  updateWizardBlacklist: 'updateWizardBlacklist'
};

const startCreateBlacklistWizard = createAction(
  types.startCreateBlacklistWizard
);
const stopCreateBlacklistWizard = createAction(types.stopCreateBlacklistWizard);
const setCurrentStep = createAction(types.setCurrentStep);
const updateWizardBlacklist = createAction(types.updateWizardBlacklist);

const backInCreateWizard = () => {
  return (dispatch, getState) => {
    const currentStep = getState().blacklist.createWizard.step;
    if (currentStep == null || currentStep === 'identity') {
      return; //no-op
    }
    if (currentStep === 'block') {
      dispatch(setCurrentStep('identity'));
    }
  };
};

const nextInCreateWizard = item => {
  return (dispatch, getState) => {
    const currentStep = getState().blacklist.createWizard.step;
    if (currentStep == null) {
      return; //no-op
    }
    // La lista se recarga sola (onCreated/onClosed del asistente), con sus filtros.
    if (currentStep === 'success') {
      dispatch(stopCreateBlacklistWizard());
      return;
    }
    if (currentStep === 'identity') {
      dispatch(setCurrentStep('block'));
    }
    dispatch(updateWizardBlacklist(item));
    if (currentStep === 'block') {
      dispatch(BlacklistActions.createBlacklist(item)).then(() => {
        dispatch(setCurrentStep('success'));
        dispatch(destroy('createBlacklistForm'));
      });
    }
  };
};

/**
 * Used when the user closes the wizard without finishing.
 * That happens when closes the modal.
 */
const closeCreateBlacklistWizard = () => {
  return dispatch => {
    dispatch(destroy('createBlacklistForm'));
    dispatch(stopCreateBlacklistWizard());
  };
};

export { types };
export default {
  startCreateBlacklistWizard,
  closeCreateBlacklistWizard,
  nextInCreateWizard,
  backInCreateWizard
};
